import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const CommentHistoryStyle = StyleSheet.create({
    mainContainer: {
        flex: 1,
        backgroundColor: appColors.lightBackgroundColor
    },
    mobileContent: {
        flexDirection: "row",
        gap: 5,
        alignItems: "center"
    },
    tabContent: {
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 5
    },
    cardStyle: {
        borderRadius: 16,
        borderColor: "transparent",
        backgroundColor: appColors?.light,
        padding: 15,
        marginHorizontal: 2,
        marginTop: 20
    },
    labelStyle: {
        fontSize: fontSize.smallerFontSize,
        color: appColors.labelColor
    },
    inputStyle: {
        padding: 0,
        margin: 0
    },
    inputContainer: {
        backgroundColor: appColors.lightBackgroundColor,
        paddingHorizontal: 10,
        marginHorizontal: 8
    },
    container: {
        marginTop: 8,
        flex: 1
    },
    buttonStyle: {
        borderRadius: 7,
        backgroundColor: appColors.primary,
        borderColor: appColors.primary,
    },
    textStyle: {
        color: appColors.light,
        fontFamily: appFonts.bold,
        fontSize: fontSize.smallerFontSize,
    },
    buttonContainer: {
        alignSelf: 'flex-end',
    },
    commentStyle: {
        color: appColors.lightDark,
        fontSize: fontSize.smallHeaderFontSize,
        fontFamily: appFonts.medium,
        lineHeight: 28
    },
    font: {
        fontFamily: appFonts.medium
    }

})